import { render, staticRenderFns } from "./directive.vue?vue&type=template&id=10192f06&scoped=true&"
import script from "./directive.vue?vue&type=script&lang=js&"
export * from "./directive.vue?vue&type=script&lang=js&"
import style0 from "./directive.vue?vue&type=style&index=0&id=10192f06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10192f06",
  null
  
)

export default component.exports